import { atom } from 'recoil'
import { IMaintenanceProcess } from '../maintenance.types.ts'

interface IMaintenanceBlankSchemasAtomState {
  items: IMaintenanceProcess[]
}

const maintenanceProcessesAtom = atom<IMaintenanceBlankSchemasAtomState>({
  key: 'maintenance/processes',
  default: { items: [] },
})
export default maintenanceProcessesAtom
